export default __webpack_public_path__ + "static/1-105e0eb95bf0c7567044af8f6fea3433.png";